<div class="row justify-content-end p-3">
    <div class="col-3 my-2">
        <mat-form-field appearance="outline" class="search-bar">
            <mat-label class="search-bar-label">
                <mat-icon class="search-icon">search</mat-icon>
                <span>Search</span>
            </mat-label>
            <input matInput (keyup)="applyPropertyManagerSearch($event)" [(ngModel)]="propertyManagerSearchKeyword">
            <button type="button" *ngIf="propertyManagerSearchKeyword" matSuffix mat-icon-button aria-label="Clear" (click)="clearPropertyManagerSearch()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="mt-2 mb-3">
        <div class="table-responsive">
            <table mat-table matSort [dataSource]="propertyManagerDataSource" class="mat-elevation-z8">
                <ng-container [matColumnDef]="column.column" *ngFor="let column of propertyManagerDisplayedColumns">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.display }}</th>
                    <ng-container [ngSwitch]="column.column">
                    <ng-container *ngSwitchCase="'price'">
                        <td mat-cell *matCellDef="let element">
                            {{ element[column.column] | currency }}
                        </td>
                    </ng-container>
                    <ng-container *ngSwitchCase="'deductible'">
                        <td mat-cell *matCellDef="let element">
                            {{ element[column.column] | currency }}
                        </td>
                    </ng-container>
                        <ng-container *ngSwitchDefault>
                            @if(column.renderHtml) {
                                <td mat-cell *matCellDef="let element" [innerHTML]="element[column.column]"></td>
                            } @else {
                                <td mat-cell *matCellDef="let element">{{ element[column.column] }}</td>
                            }
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedPropertyMangerColumnNames"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedPropertyMangerColumnNames;" (click)="onRowClick(row)"></tr>
                @if(loading && propertyManagerSearchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            No data matching the filter "{{ propertyManagerSearchKeyword }}"
                        </td>
                    </tr>
                }
                @if (loading && !propertyManagerSearchKeyword) {
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                            Loading Price Rates..
                        </td>
                    </tr>
                }
            </table>
        </div>
        <div *ngIf="loading.value" class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
        </div>
        <div class="d-flex paginator-row align-items-baseline">
            <div class="col-10">
                <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="propertyMangagerPageSize || 10" [length]="propertyManagerTableLength" aria-label="Select page" showFirstLastButtons></mat-paginator>
            </div>
            <div class="col-2 d-flex align-items-baseline">
                <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber" step="1">
                </mat-form-field>
                <button mat-raised-button (click)="onGoToPropertyMangerPageClick()" class="action-button">Go</button>
            </div>
        </div>
    </div>
</div>